var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "section",
        {
          staticClass: "vks-workspace-guide",
          attrs: { "aria-label": "Getting Around" },
        },
        [
          _c("div", { staticClass: "vks-workspace-guide-header" }, [
            _c("h2", { staticClass: "vks-workspace-guide-title" }, [
              _vm._v("Getting Around"),
            ]),
            _c(
              "button",
              {
                staticClass: "vks-workspace-guide-close",
                attrs: {
                  type: "button",
                  "aria-label": "Close Getting Around guide",
                  title: "Close",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(" × ")]
            ),
          ]),
          _vm._m(0),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vks-workspace-guide-body" }, [
      _c("div", { staticClass: "vks-workspace-guide-grid" }, [
        _c("div", { staticClass: "vks-workspace-guide-item" }, [
          _c("h3", { staticClass: "vks-workspace-guide-label" }, [
            _vm._v("Header menus"),
          ]),
          _c("ul", { staticClass: "vks-workspace-guide-list" }, [
            _c("li", [
              _c("strong", [_vm._v("Search")]),
              _vm._v(
                " — reset the current locus search and return to the start screen. "
              ),
            ]),
            _c("li", [
              _c("strong", [_vm._v("Import / Export")]),
              _vm._v(
                " — save or restore a full session, or download the variant data table. "
              ),
            ]),
            _c("li", [
              _c("strong", [_vm._v("Help → Getting Around")]),
              _vm._v(" — reopen this guide after closing it. "),
            ]),
            _c("li", [
              _vm._v(" On the right of the header: "),
              _c("strong", [_vm._v("Region zoom")]),
              _vm._v(" expands or focuses the plotted interval; the "),
              _c("strong", [_vm._v("table")]),
              _vm._v(" button opens the variant data table; the "),
              _c("strong", [_vm._v("Actions")]),
              _vm._v(" button opens guided filtering tools. "),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "vks-workspace-guide-item" }, [
          _c("h3", { staticClass: "vks-workspace-guide-label" }, [
            _vm._v("Side drawers"),
          ]),
          _c("p", { staticClass: "vks-workspace-guide-text" }, [
            _vm._v(
              " The tabs on the right open a control panel for each analysis section (Associations, Credible sets, Global enrichment, Genes, and others as they become available). Use a drawer to set filters and plot options for that section; the main canvas shows the resulting tracks and visualizations. "
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }